const isDev = process.env.REACT_APP_DEV === "true";

export default {
  apiAddress: isDev
    ? "http://localhost:5005/"
    : `${process.env.REACT_APP_BACKEND_REALM}/`,
  headerTitle: "CYBERPUNK 2077 INTERACTIVE MAP",
};
